import React, { Component } from 'react';
import Modal from 'react-modal';
import {
   INTRO,
   PUBLIC,
   DURATION,
   DIFFICULTY,
   PICTURE,
   EVENT_DATE,
   TITLE,
   TREASURE_DESCRIPTION,
   TREASURE_TYPE
} from "../../constants/Game";
import withAuthorization from "../auth/withAuthorization";
import { withRouter } from "react-router-dom";
import { reduxForm } from "redux-form";
import { deleteGame, fetchGame, updateGame } from "../../actions";
import { connect} from "react-redux";
import { renderArea, WizardHeader } from "../common_page_elements";
import Field from "redux-form/es/Field";
import { minLength12, minLength2, required } from "../../constants/ValidationRules";
import { DifficultyLevelChoice } from "../huntcomponents/DifficultyLevelChoice";

import '../../global.css';
import { ConfirmDelete } from "../huntcomponents/dialogs";
import {deleteFileInFbStorage, PhotoUpload, processFile} from "../image/PhotoUpload";
import { ButtonFileInput } from "../image/SimpleFileInput";
import { TreasureTypeChoice } from "../huntcomponents/TreasureTypeChoice";

class WizardDetails extends Component {
   constructor(props) {
      super(props);

      const difficultyLevel = props.selectedGame ? props.selectedGame[DIFFICULTY] : null;
      const treasureType = props.selectedGame ? props.selectedGame[TREASURE_TYPE] : null;

      this.state = {
         difficultyLevel,
         treasureType,
         loadingHuntImage: false,
         deleteConfirmIsOpen: false
      };

      this.onNext = this.onNext.bind(this);
      this.delete = this.delete.bind(this);
      this.onDifficultyChange = this.onDifficultyChange.bind(this)
      this.openDeleteModal = this.openDeleteModal.bind(this);
      this.closeDeleteModal = this.closeDeleteModal.bind(this);
      this.photoUploadComplete = this.photoUploadComplete.bind(this);
      this.errorUploadingPhoto = this.errorUploadingPhoto.bind(this);
      this.onDrop = this.onDrop.bind(this);
      this.onTreasureTypeChange = this.onTreasureTypeChange.bind(this);
   }

    componentDidMount () {
        window.scrollTo(0, 0)
    }

    openDeleteModal(index) {
        this.setState({deleteConfirmIsOpen: true, indexSelected: index});
    }

    closeDeleteModal() {
        this.setState({deleteConfirmIsOpen: false, indexSelected: -1}
        );
    }

   // callback from PhotoUpload
   photoUploadComplete(newUrl) {
      const game = this.game();

      if (newUrl == null && game.hunt_picture == null) {
         this.setState( { loadingHuntImage: false } )
         return;
      }

      const values = { hunt_picture: newUrl }
      updateGame(game.id, game.isPublic, values,
         () => { this.setState( { loadingHuntImage: false } ) });
   }

   // callback from PhotoUpload
   errorUploadingPhoto(errorMsg) {

      this.setState( { loadingHuntImage: false } )

      if (!!errorMsg) {
         alert(errorMsg)
      }
   }

   // callback from file chooser for image upload
   onDrop(files) {
      const file = files[0]
      if (!file) {
         return;
      }
      // this will trigger file processing and image upload by PhotoUpload component.
      this.setState( { loadingHuntImage: true } )
      const game = this.game();
      const hasOldPhoto = !! game.hunt_picture;
      if (hasOldPhoto) {
         deleteFileInFbStorage(game.hunt_picture);
      }

      processFile(file, 'hunt_picture', null,
         game.id, game.authorId,
         game.isPublic,
         game.created,
         this.photoUploadComplete, this.errorUploadingPhoto )
   }

   onTreasureTypeChange(event, newValue) {
      this.setState( { treasureType: newValue });
   }

   delete() {
        const {id} = this.props.match.params;
        const game = this.props.games[id];

        const isPublic = game.isPublic;

        this.props.deleteGame(id, isPublic, () => {
            this.props.history.push('/games');
        });
    }

    onNext(values) {
        const { updateGame, history } = this.props;

       const isPublic = this.game()[PUBLIC];
        const id = this.gameId();

        if (!this.state.difficultyLevel) {
            alert("Please select a Difficulty rating.");
            return;
        }

        // get bounds into valuesm as well, then publish

        updateGame(id, isPublic, values, () => {
            history.push(`/games/${id}/new5`);
        });
    }

    onDifficultyChange(event, newValue) {

        this.setState( { difficultyLevel: newValue });
    }

    // helper to grab the id from the URL
    gameId() {
        return this.props.match.params.id;
    }

    // helper to get the game object.
    game() {
        const {games} = this.props;
        return games[this.gameId()];
    }

    render() {
        const { games, handleSubmit } = this.props;

        const id = this.gameId();

        // If we don't have data, fetch it and return
        if (!games || !games[id]) {
            // invalid state for step two of wizard (todo: more invalid states)
            fetchGame(id);
            return <div>Loading... </div>
        }

        const explanation = "Add more details to your hunt.  Write a compelling introduction, optionally add an image, and indicate the "
                + "expected difficulty of the hunt.  As with all your input, you can come back and change these later.";

       const gamePhoto = this.game()[PICTURE];
       const hasPhoto = !!gamePhoto;
       const photoButtonText = hasPhoto ? "Change image" : "Choose image";

       const game = this.game();
       const isEvent = !! game[EVENT_DATE];

       const kindOfTreasureExplanation = isEvent
          ? "A Event Hunt often has something of value at its ending -- cash, gold or other valuable" +
          " objects!" +
          " But of course you can choose something else interesting, such as" +
          " as object you place, a geo cache, something already there." +
          " Or really anything -- anything that's findable."

          : "The treasure -- or hunt ending -- does not have to be cash, gold coins or other valuable" +
          " objects. " +
          " In a hunt played over and over again, that wouldn't work. It could instead be some interesting" +
          " object you placed, a geo cache, something already there such as a sign, or something occurring in nature." +
          " Or really anything -- anything that's findable.";

       return (
            <div className='editor'>

                <WizardHeader
                    game={this.game()}
                    backOutText="Cancel"
                    backOutAction={this.openDeleteModal}
                    index={2}
                    stepName="Step 3:  Details"
                    stepExplanation={explanation}
                />

                <p className="secondary-text big-bottom-margin">
                    The introduction is your description of your hunt to possible users.  It gives them an idea how the
                    hunt will go, what to expect, the cool things they'll see, and what they should know before starting.  It might also give them
                    a clue about the ending or how to play the clues ahead of them.
                </p>

                <form onSubmit={handleSubmit(this.onNext)}>

                    <Field
                        name={INTRO}
                        type="textarea"
                        component={renderArea}
                        rows={6}
                        label="Introduction"
                        placeholder="Describe this game for your players."
                        validate={[required, minLength12]}
                    />

                   <p className="secondary-text big-top-margin bottom-margin">
                   Optional.  Add a photo or illustration to introduce this hunt.  This picture is shown
                      on the hunt summary page in the app, landscape-oriented images work best. </p>

                   <p>If taking a picture on your phone, shoot in landscape (sideways) so photo doesn't appear rotated. </p>

                   <label htmlFor="photo_upload" className="">Hunt Picture</label>
                   <div className="form-group right-margin clear-left">
                      <PhotoUpload
                         id='photo_upload'
                         url={gamePhoto}
                         loading={this.state.loadingHuntImage}
                         editable={true}
                         hideNoneText={true}
                         deletedCallback={() => {deleteFileInFbStorage(gamePhoto); this.photoUploadComplete(null)}}
                         errorCallback={this.errorUploadingPhoto}
                      />
                   </div>
                   <div className="bottom-margin clear-left">
                      <ButtonFileInput
                         labelText={photoButtonText}
                         onChange={this.onDrop}
                         accept="image/*"
                         id="hunt_picture"
                      />
                   </div>

                   <p className="secondary-text big-top-margin">
                        How difficult would you like to make this hunt?  Making a difficult but fun hunt takes a lot
                        of effort and skill, and for most people more difficult does not equal more fun.
                    </p>

                    <DifficultyLevelChoice
                        difficultyLevel={this.state.difficultyLevel}
                        onChange={this.onDifficultyChange}
                    />

                   <div className="secondary-text bottom-margin"> <span className="black"><b>Duration</b></span>.  We'll estimate the distance your user
                        must travel to complete the hunt, and its duration, based on the location of your clues.
                    </div>

                   <label htmlFor="treasure_para" className="">Ending</label>
                   <p className="secondary-text bottom-margin" id='treasure_para'>
                      {kindOfTreasureExplanation}
                   </p>

                   <TreasureTypeChoice
                      useShort={false}
                      treasureType={this.state.treasureType}
                      onChange={this.onTreasureTypeChange}
                   />

                   <p className="secondary-text small-bottom-margin" id='treasure_para'>
                      Add a message to the user after game is over.  Might contain description of treasure, congratulatory message, call to action, or anything.
                   </p>

                   <Field
                      name={TREASURE_DESCRIPTION}
                      type="textarea"
                      component={renderArea}
                      rows={3}
                      label="Message"
                      validate={[required, minLength2]}
                   />
                   <p className="big-bottom-margin secondary-text">Note you can come back and change almost all of these fields later.</p>

                   <button type="button" onClick={this.openDeleteModal} className="btn btn-danger right-margin">Cancel</button>
                    <button type="submit" className="btn btn-primary left-margin">Next</button>
                </form>
                <Modal
                    isOpen={this.state.deleteConfirmIsOpen}
                    onRequestClose={this.closeDeleteModal}
                    className="confirm-modal-content"
                    overlayClassName="my-modal-overlay"
                >
                    <ConfirmDelete
                        title="Abandon Hunt"
                        message="Are you sure you want to permanantly delete this new treasure hunt?"
                        confirmText="Yes"
                        onConfirm={this.delete}
                        closeModalCallback={this.closeDeleteModal}
                    />
                </Modal>
            </div>
        )
    }
}

const authCondition = (authUser) => !!authUser;

const mapStateToProps = (state) => {
    const { games, selectedGameId } = state;

    const selectedGame = (games && selectedGameId) ? games[state.selectedGameId] : null;

    const existingDescription = selectedGame ? selectedGame[TREASURE_DESCRIPTION] : null;
    const descriptionFill = existingDescription ? existingDescription
         : selectedGame ? "Congratulations for finishing " + selectedGame[TITLE] + "!"
                        : "";

    const initialValues = selectedGame
        ?  {
            [INTRO]: state.games[state.selectedGameId][INTRO],
            [DURATION]: state.games[state.selectedGameId][DURATION],
            [TREASURE_DESCRIPTION]: descriptionFill
        }
        : {
          [TREASURE_DESCRIPTION]: descriptionFill
       };

    return {
        authUser: state.sessionState.authUser,
        user: state.userState.user,
        games: state.games,
        initialValues,
        selectedGame
    }
};

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
WizardDetails = reduxForm({
    form: 'NewGame4Form' // a unique identifier for this form
})(
    connect(null, { updateGame }
    )(WizardDetails));

WizardDetails = withRouter(connect(mapStateToProps, { deleteGame })(WizardDetails));
WizardDetails = withAuthorization(authCondition)(WizardDetails);

export default WizardDetails;



// WEBPACK FOOTER //
// ./src/components/huntwizard/WizardDetails.js